import PillDisplay from "./PillDisplay";

export type { PillDisplayType } from "./PillDisplay";

export default PillDisplay;
